import { ArrayStorage } from "app/pages/sales-intelligence/services/storage/array-storage/factory";
import createColumnSuggestionsCommonStorage from "./common-storage/factory";
import { SUGGESTIONS_STORAGE_KEY } from "./const";
import columnSuggestionsLocalStorageProvider from "./local-storage/provider";

const SEEN_SUGGESTIONS_STORAGE_KEY = `${SUGGESTIONS_STORAGE_KEY}:seen-suggestions`;

export const seenSuggestionsStorage = new ArrayStorage<string>(SEEN_SUGGESTIONS_STORAGE_KEY, sessionStorage);

export const columnSuggestionsLocalStorage = createColumnSuggestionsCommonStorage(
    columnSuggestionsLocalStorageProvider,
);
